import ExcelJS from "exceljs";
import { numberToExcelColumn } from "../../../../utils/numberToExcelColumn";

const findTotalCost = (array) => {
  return Number(
    array?.reduce(
      (accumulator, currentObject) =>
        accumulator + Number(currentObject?.cost || 0),
      0
    )
  ).toFixed(2);
};
export default function monthlyExcel(QCostSheetData) {
  const HEADERS_DATA = QCostSheetData?.quotation_cost_sheet_heading;
  const HEADERS_LENGTH = HEADERS_DATA.length;
  const BASIC_INFO = QCostSheetData?.quotation_cost_sheet_basic_info;
  const COST_DETAILS = QCostSheetData?.quotation_cost_sheet_cost_details;

  let empHeaders = [
    "QUOTATION ID",
    "ACTUAL PROFESSION",
    "VISA PROFESSION",
    "PROFESSION LEVEL",
    "GENDER",
    "NATIONALITY",
    "QUANTITY",
  ]; // these are fixed columns
  let fixedHeadersCount = empHeaders.length;
  let govtFeeHeaders = [];
  let slaFeeHeaders = [];
  const headers = [];

  const data = [];
  for (let i = 0; i < BASIC_INFO.length; i++) {
    let item = {
      id: BASIC_INFO[i]?.id,
      quotation_id: QCostSheetData?.quotation?.quotation_number,
      actual_profession: BASIC_INFO[i]?.job_position?.name,
      visa_profession: BASIC_INFO[i]?.visa_profession?.name,
      profession_Level: BASIC_INFO[i]?.profession_level?.name,
      gender: BASIC_INFO[i]?.gender,
      nationality: BASIC_INFO[i]?.nationality?.name,
      quantity: BASIC_INFO[i]?.quantity,
    };
    data.push(item);
  }
  const result = [];
  const rateCategoryMap = {};
  HEADERS_DATA.forEach((heading) => {
    rateCategoryMap[heading.id] = heading?.rate_category?.name;
  });

  COST_DETAILS.forEach((costDetail) => {
    const {
      quotation_cost_sheet_profession_basic_information_id,
      quotation_cost_sheet_heading_id,
      cost,
    } = costDetail;
    const head = HEADERS_DATA.find(
      (heading) => heading.id === quotation_cost_sheet_heading_id
    );
    let heading;
    if (head?.type === "Default") {
      heading = head?.rate_category_item?.name;
    } else {
      heading = head?.rate_category_item_name;
    }
    const rateCategory = rateCategoryMap[quotation_cost_sheet_heading_id];
    let professionEntry = result.find(
      (entry) =>
        entry.quotation_cost_sheet_profession_basic_information_id ===
        quotation_cost_sheet_profession_basic_information_id
    );
    if (!professionEntry) {
      professionEntry = {
        quotation_cost_sheet_profession_basic_information_id,
        data: [],
      };
      result.push(professionEntry);
    }

    professionEntry.data.push({
      heading,
      cost,
      rate_category: rateCategory,
    });
  });

  for (let i = 0; i < HEADERS_LENGTH; i++) {
    const qcs = HEADERS_DATA[i];
    let head =
      qcs.type === "Default"
        ? qcs.rate_category_item?.name
        : qcs.rate_category_item_name;
    let rateCategory = qcs?.rate_category?.name;
    switch (rateCategory) {
      case "Employee Salary Package":
        if (empHeaders.includes(head)) break;
        empHeaders.push(head);
        break;
      case "Government Fee":
        if (govtFeeHeaders.includes(head)) break;
        govtFeeHeaders.push(head);
        break;
      case "SoundLine Fee":
        if (slaFeeHeaders.includes(head)) break;
        slaFeeHeaders.push(head);
        break;
    }
  }
  headers.push(
    ...[...empHeaders],
    "Total Emp. Salary Package",
    ...[...govtFeeHeaders],
    "Total Gov. Fees",
    ...[...slaFeeHeaders],
    "Total Soundline Fees"
  );

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  // Set column widths
  for (let i = 1; i <= HEADERS_LENGTH + 20; i++) {
    const column = sheet.getColumn(i);
    sheet.getColumn(i).alignment = { horizontal: "center" };
    column.width = 22;
    column.eachCell({ includeEmpty: true }, (cell) => {
      cell.alignment = { wrapText: true };
    });
  }

  // Set header height
  sheet.getRow(1).height = 30;
  sheet.getRow(2).height = 40;
  sheet.getRow(2).alignment = {
    horizontal: "center",
    vertical: "center",
    wrapText: true,
  };
  sheet.getRow(1).alignment = {
    horizontal: "center",
    vertical: "center",
    wrapText: true,
  };

  sheet.getCell("A1").fill = {
    pattern: "solid",
    fgColor: { argb: "FFF" }, // Gray color
  };

  const headerStyle = {
    alignment: { horizontal: "center", vertical: "center" },
    font: { bold: true, size: 12 },
  };

  const range1 = empHeaders.length + 1;
  const range2 = range1 + govtFeeHeaders.length + 1;
  const range3 = range2 + slaFeeHeaders.length + 1;

  // sheet.getCell("A1").style = {...headerStyle};
  // sheet.getCell("A3").style = {...headerStyle};
  // sheet.getCell(`${numberToExcelColumn(range1+1)}3`).style = {...headerStyle};
  // sheet.getCell(`${numberToExcelColumn(range2+1)}3`).style = {...headerStyle};

  sheet.getCell("A1").style = { ...headerStyle };
  sheet.getRow(1).style = { ...headerStyle };
  sheet.getCell(`${numberToExcelColumn(range1 + 1)}1`).style = {
    ...headerStyle,
  };
  sheet.getCell(`${numberToExcelColumn(range2 + 10)}1`).style = {
    ...headerStyle,
  };

  sheet.mergeCells(`A1:${numberToExcelColumn(range1)}1`);
  sheet.mergeCells(
    `${numberToExcelColumn(range1 + 1)}1:${numberToExcelColumn(range2)}1`
  );
  sheet.mergeCells(
    `${numberToExcelColumn(range2 + 1)}1:${numberToExcelColumn(range3)}1`
  );
  sheet.mergeCells(
    `${numberToExcelColumn(range3 + 1)}1:${numberToExcelColumn(range3 + 1)}2`
  );

  sheet.getCell("A1").value = "EMP Salary Package";
  sheet.getCell(`${numberToExcelColumn(range1 + 1)}1`).value =
    "Government Fees (12 Months)";
  sheet.getCell(`${numberToExcelColumn(range2 + 1)}1`).value =
    "SLA Fees (24 Months)";
  sheet.getCell(`${numberToExcelColumn(range3 + 1)}2`).value =
    "Total Monthly Per Head Cost";
  sheet.getColumn(`${numberToExcelColumn(range3 + 1)}`).width = 28;
  sheet.getColumn(`${numberToExcelColumn(range3 + 1)}`).alignment = {
    horizontal: "center",
    vertical: "center",
  };

  sheet.getRow(2).font = { bold: true };

  sheet.getCell("A1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "ff949494" }, // White color in ARGB format
  };
  sheet.getCell(`${numberToExcelColumn(range2 + 1)}1`).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "ffffccbc" }, // Cream color in ARGB format
  };

  sheet.getCell("AT1").alignment = {
    wrapText: true,
  };
  for (let row = 1; row <= 1 + data?.length + 1; row++) {
    for (let col = range1 + 1; col <= range2; col++) {
      const cell = sheet.getCell(row, col);
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
      };

      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } }, // Black color
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    }
  }

  function getExcelColumnName(n) {
    let result = "";
    while (n >= 0) {
      result = String.fromCharCode(65 + (n % 26)) + result;
      n = Math.floor(n / 26) - 1;
    }
    return result;
  }

  for (let i = 0; i < headers.length; i++) {
    const columnName = getExcelColumnName(i);
    sheet.getCell(columnName + "2 ").value = headers[i];
  }

  for (let i = 0; i < data.length; i++) {
    const row = sheet.getRow(i + 3);
    row.getCell("A").value = data[i].quotation_id;
    row.getCell("B").value = data[i].actual_profession;
    row.getCell("C").value = data[i].visa_profession;
    row.getCell("D").value = data[i].profession_Level;
    row.getCell("E").value = data[i].gender;
    row.getCell("F").value = data[i].nationality;
    row.getCell("G").value = data[i].quantity;
  }

  const costDetailsMap = {};
  result.forEach((costDetail) => {
    costDetailsMap[
      costDetail.quotation_cost_sheet_profession_basic_information_id
    ] = costDetail.data;
  });

  // Combine basic_information with cost details
  const final_cost_sheet = data.map((info) => ({
    ...info,
    costsheet: costDetailsMap[info.id] || [], // Use empty array if no matching cost details found
  }));

  const finalCostSheetUpdated = final_cost_sheet.map((row) => {
    row?.costsheet?.splice(range1 - fixedHeadersCount, 0, {
      heading: "Total Emp. Salary Package",
      cost: 0,
      rate_category: "Employee Salary Package",
    });
    row?.costsheet?.splice(range2 - fixedHeadersCount, 0, {
      heading: "Total Gov. Fees",
      cost: 0,
      rate_category: "Government Fee",
    });
    row?.costsheet?.splice(range3 - fixedHeadersCount, 0, {
      heading: "Total Soundline Fees",
      cost: 0,
      rate_category: "Government Fee",
    });
    const _updatedRow = {
      ...row,
    };
    return _updatedRow;
  });

  for (let i = 0; i < finalCostSheetUpdated.length; i++) {
    const row = sheet.getRow(i + 3);
    const professionData = finalCostSheetUpdated[i]?.costsheet;
    console.log(professionData, "profession data", headers);
    const EmployeeSalaryPackage = professionData.filter(
      (data) => data?.rate_category == "Employee Salary Package"
    );
    const GovernmentFee = professionData.filter(
      (data) => data?.rate_category == "Government Fee"
    );
    const SoundLineFee = professionData.filter(
      (data) => data?.rate_category == "SoundLine Fee"
    );
    const totalEmployeeSalaryPackage = findTotalCost(EmployeeSalaryPackage);
    const totalGovernmentFee = findTotalCost(GovernmentFee);
    const totalSoundlineFee = findTotalCost(SoundLineFee);
    let sum = 0;
    for (let j = fixedHeadersCount; j <= headers.length; j++) {
      const header = headers[j];

      const dataEntry = professionData?.find(
        (entry) => entry.heading === header
      );
      if (dataEntry) {
        row.getCell(`${numberToExcelColumn(j + 1)}`).value = dataEntry.cost;
        sum += Number(dataEntry.cost);
      } else row.getCell(`${numberToExcelColumn(j + 1)}`).value = "";

      if (header == "Total Emp. Salary Package") {
        row.getCell(`${numberToExcelColumn(j + 1)}`).value =
          totalEmployeeSalaryPackage;
      }
      if (header == "Total Gov. Fees") {
        row.getCell(`${numberToExcelColumn(j + 1)}`).value = totalGovernmentFee;
      }
      if (header == "Total Soundline Fees") {
        row.getCell(`${numberToExcelColumn(j + 1)}`).value = totalSoundlineFee;
      }
    }
    row.getCell(`${numberToExcelColumn(range3 + 1)}`).value =
      Number(sum).toFixed(2);
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "MonthlyExcel.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    +URL.revokeObjectURL(url);
  });
}
